(() => {
  const SELF_SRC = (document.currentScript && document.currentScript.src) || '';
  const WORDS_URL = SELF_SRC
    ? SELF_SRC.split('?')[0].replace(/pampas-predictive-search\.js$/, 'pampas-search-words.json')
    : null;

  const DEBUG = /pampas_debug/.test(location.search);
  let WORDS = null;
  let wordsPromise = null;

  const loadWords = () => {
    if (WORDS) return Promise.resolve(WORDS);
    if (!WORDS_URL) { WORDS = []; return Promise.resolve(WORDS); }
    if (!wordsPromise) {
      wordsPromise = fetch(WORDS_URL, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : []))
        .then((list) => { WORDS = Array.isArray(list) ? list : []; if (DEBUG) console.log('[pampas] words loaded:', WORDS.length); return WORDS; })
        .catch((e) => { console.warn('[pampas] words failed', e); WORDS = []; return WORDS; });
    }
    return wordsPromise;
  };

  const styles = `
    .search__results:has(.pampas-predictive-results) {
      display: block;
      max-height: calc(100vh - 170px);
      overflow-y: auto;
      padding: 18px clamp(18px, 3vw, 34px) 26px;
      color: var(--pm-color-text);
      background: var(--pm-color-page);
      border-top: var(--pm-control-border-width) solid var(--pm-color-border);
      box-shadow: var(--pm-shadow-medium);
    }

    .pampas-predictive-results {
      width: min(100%, 920px);
      margin-inline: auto;
      direction: rtl;
      text-align: right;
    }

    .pampas-predictive-results__heading {
      margin: 0 0 10px;
      color: var(--pm-color-primary);
      font-size: 21px;
      font-weight: 700;
    }

    .pampas-predictive-results__list {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px 16px;
      margin: 0 0 18px;
      padding: 0;
      list-style: none;
    }

    .pampas-predictive-results__link {
      display: flex;
      min-height: 70px;
      align-items: center;
      gap: 12px;
      padding: 8px;
      color: var(--pm-color-text);
      background: var(--pm-color-surface);
      border: var(--pm-control-border-width) solid var(--pm-color-border);
      border-radius: var(--pm-radius-small);
      text-decoration: none;
    }

    .pampas-predictive-results__link:hover,
    .pampas-predictive-results__link:focus-visible {
      color: var(--pm-color-primary);
      border-color: var(--pm-color-primary);
      background: color-mix(in srgb, var(--pm-color-primary) var(--pm-color-mix-hover), var(--pm-color-page));
    }

    .pampas-predictive-results__image {
      flex: 0 0 52px;
      width: 52px;
      height: 52px;
      object-fit: cover;
      border-radius: var(--pm-radius-small);
      background: var(--pm-color-surface-strong);
    }

    .pampas-predictive-results__info {
      display: grid;
      min-width: 0;
      gap: 4px;
    }

    .pampas-predictive-results__title {
      line-height: 1.35;
    }

    .pampas-predictive-results__prices {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 4px 8px;
      direction: rtl;
      font-size: 14px;
      line-height: 1.25;
    }

    .pampas-predictive-results__price {
      color: var(--pm-color-primary);
      font-weight: 700;
    }

    .pampas-predictive-results__compare-price {
      color: color-mix(in srgb, var(--pm-color-text) 58%, transparent);
      text-decoration: line-through;
    }

    .pampas-predictive-results__all {
      display: inline-flex;
      min-height: 44px;
      align-items: center;
      justify-content: center;
      padding: 9px 20px;
      color: var(--pm-color-on-primary);
      background: var(--pm-color-primary);
      border-radius: var(--pm-radius-pill);
      text-decoration: none;
    }

    @media (max-width: 749px) {
      .search__results:has(.pampas-predictive-results) {
        max-height: calc(100vh - 118px);
        padding: 14px;
      }

      .pampas-predictive-results__list {
        grid-template-columns: 1fr;
      }
    }
  `;

  const addStyles = () => {
    if (document.getElementById('PampasPredictiveSearchStyles')) return;
    const style = document.createElement('style');
    style.id = 'PampasPredictiveSearchStyles';
    style.textContent = styles;
    document.head.appendChild(style);
  };

  const createLink = (href, className, text) => {
    const link = document.createElement('a');
    link.href = href;
    link.className = className;
    link.textContent = text;
    return link;
  };

  /*
   * שופיפיי לא משלים תחיליות בעברית ולא מחזיר דבר על שאילתה קצרה.
   * לכן על כל הקלדה מרכיבים רשימת שאילתות: המונח עצמו (אם 3 אותיות ומעלה)
   * + עד 3 מילים שלמות מהמילון שמתחילות באותה תחילית.
   * "זר" -> זרי, זרון, זרים | "פמו" -> פמוטי, פמוט, פמוטים
   */
  const buildQueries = (term) => {
    const parts = term.split(/\s+/).filter(Boolean);
    if (!parts.length) return [term];

    const last = parts[parts.length - 1];
    const head = parts.slice(0, -1).join(' ');
    const queries = [];

    if (last.length >= 3) queries.push(term);

    if (WORDS && WORDS.length) {
      WORDS.filter((w) => w.length >= 3 && w !== last && w.indexOf(last) === 0)
        .slice(0, 3)
        .forEach((w) => queries.push(head ? head + ' ' + w : w));
    }

    return queries.length ? queries : [term];
  };

  const renderResults = (component, products, searchTerm) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'pampas-predictive-results';

    if (products.length) {
      const heading = document.createElement('p');
      heading.className = 'pampas-predictive-results__heading';
      heading.textContent = 'מוצרים';
      wrapper.appendChild(heading);

      const list = document.createElement('ul');
      list.className = 'pampas-predictive-results__list';

      products.slice(0, 6).forEach((product) => {
        const item = document.createElement('li');
        const link = createLink(product.url, 'pampas-predictive-results__link', '');

        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.className = 'pampas-predictive-results__image';
          image.loading = 'lazy';
          link.appendChild(image);
        }

        const info = document.createElement('span');
        info.className = 'pampas-predictive-results__info';

        const title = document.createElement('span');
        title.className = 'pampas-predictive-results__title';
        title.textContent = product.title;
        info.appendChild(title);

        if (product.price) {
          const prices = document.createElement('span');
          prices.className = 'pampas-predictive-results__prices';

          const price = document.createElement('span');
          price.className = 'pampas-predictive-results__price';
          price.textContent = product.price;
          prices.appendChild(price);

          if (product.compareAtPrice) {
            const comparePrice = document.createElement('span');
            comparePrice.className = 'pampas-predictive-results__compare-price';
            comparePrice.textContent = product.compareAtPrice;
            prices.appendChild(comparePrice);
          }

          info.appendChild(prices);
        }

        link.appendChild(info);
        item.appendChild(link);
        list.appendChild(item);
      });

      wrapper.appendChild(list);
    } else {
      const empty = document.createElement('p');
      empty.className = 'pampas-predictive-results__heading';
      empty.textContent = 'לא נמצאו מוצרים מתאימים';
      wrapper.appendChild(empty);
    }

    const allResults = createLink(
      `${theme.routes.search}?q=${encodeURIComponent(searchTerm)}`,
      'pampas-predictive-results__all',
      'הצגת כל התוצאות'
    );
    wrapper.appendChild(allResults);

    component.predictiveSearchResults.replaceChildren(wrapper);
    component.classList.add('is-active');
    document.body.classList.add('predictive-overflow-hidden');
    component.open();
    component.input.setAttribute('aria-expanded', 'true');
  };

  /* המנוע המקורי — תבנית search.pampas-suggest, זה מה שעובד בחנות הזאת */
  const fetchProducts = (query, signal) => {
    const params = new URLSearchParams({
      q: query,
      type: 'product',
      view: 'pampas-suggest',
      'options[prefix]': 'last'
    });

    return fetch(`${theme.routes.search}?${params.toString()}`, {
      signal,
      headers: { Accept: 'application/json' }
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const raw = (data && Array.isArray(data.products)) ? data.products : [];
        if (DEBUG) console.log('[pampas] q="' + query + '" ->', raw.length);
        return raw.map((p) => ({
          title: p.title,
          url: p.url,
          image: p.image || null,
          price: p.price || null,
          compareAtPrice: p.compare_at_price || null
        }));
      })
      .catch((e) => {
        if (e.name === 'AbortError') throw e;
        console.warn('[pampas] fetch failed', query, e);
        return [];
      });
  };

  const patchPredictiveSearch = () => {
    const PredictiveSearch = customElements.get('predictive-search');

    if (!PredictiveSearch || PredictiveSearch.prototype.pampasSearchPatched) return;

    addStyles();
    loadWords();

    const prototype = PredictiveSearch.prototype;
    const originalClose = prototype.close;

    prototype.pampasSearchPatched = true;

    prototype.onChange = function () {
      const searchTerm = this.input.value.trim();

      if (this.pampasSearchTimer) clearTimeout(this.pampasSearchTimer);

      if (searchTerm.length < 2) {
        if (this.pampasSearchRequest) this.pampasSearchRequest.abort();
        this.predictiveSearchResults.replaceChildren();
        this.predictiveSearchResults.style.display = 'none';
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }

      this.classList.add('is-active');
      document.body.classList.add('predictive-overflow-hidden');

      this.pampasSearchTimer = setTimeout(() => {
        this.getSearchResults(searchTerm);
      }, 150);
    };

    prototype.getSearchResults = function (searchTerm) {
      if (this.pampasSearchRequest) this.pampasSearchRequest.abort();

      const controller = new AbortController();
      this.pampasSearchRequest = controller;
      const self = this;

      loadWords()
        .then(() => {
          const queries = buildQueries(searchTerm).slice(0, 4);
          if (DEBUG) console.log('[pampas] queries for "' + searchTerm + '":', queries);
          return Promise.all(queries.map((q) => fetchProducts(q, controller.signal)));
        })
        .then((sets) => {
          /* מזהים מוצר לפי הנתיב בלבד: כל שאילתה מחזירה את אותו מוצר עם ?_pos/_sid משלה, אז השוואה לפי ה-URL המלא הציגה אותו פעמיים */
          const seen = new Set();
          const merged = [];
          sets.forEach((set) => {
            set.forEach((p) => {
              const key = p.url ? p.url.split(/[?#]/)[0] : '';
              if (!key || seen.has(key)) return;
              seen.add(key);
              merged.push(p);
            });
          });
          if (self.input.value.trim() !== searchTerm) return;
          renderResults(self, merged, searchTerm);
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.warn(error);
          if (self.input.value.trim() === searchTerm) renderResults(self, [], searchTerm);
        });
    };

    prototype.close = function () {
      this.input.setAttribute('aria-expanded', 'false');
      if (this.pampasSearchTimer) clearTimeout(this.pampasSearchTimer);
      if (this.pampasSearchRequest) this.pampasSearchRequest.abort();
      originalClose.call(this);
    };
  };

  if (customElements.get('predictive-search')) {
    patchPredictiveSearch();
  } else {
    customElements.whenDefined('predictive-search').then(patchPredictiveSearch);
  }
})();
